import React from "react";
import { _MargauxMotinPriceListRoot } from "./MargauMotinPriceList.styled";
import { ILandingPriceListProps } from "../../../LandingInnovation/InnovationProduct/LandingPriceList/LandingPriceList";
import FlexBox from "../../../../FlexBox/FlexBox";
import Typography from "../../../../../Foundation/Typography/Typography";
import clsx from "clsx";
import PriceTag from "../../../../Tag/PriceTag";
import Divider from "../../../../Divider/Divider";
import DecorationBox from "../../../../DecorationBox/DecorationBox";

const MargauxMotinPriceList = (props: ILandingPriceListProps) => {
  const {
    price,
    product_price_vae,
    product_price_vad,
    product_display_from_mention,
    priceSubtitle,
    vaeLabel,
    vadLabel,
    className,
  } = props;
  const renderDisplayFromMention = () => {
    if (product_display_from_mention) {
      return (
        <Typography
          variant="ui4"
          style={{ lineHeight: "132%", letterSpacing: "0.12px" }}
        >
          {product_display_from_mention}
        </Typography>
      );
    }
    return null;
  };
  return (
    <_MargauxMotinPriceListRoot>
      <DecorationBox
        className="decoration-box"
        imageName="bird"
        alt="decoBox3"
        maxWidth="63px"
        enableAnimation={true}
        animationType="slideDown"
        animationDelay={800}
        animationDistance={100}
        threshold={0.4}
      />
      <div
        className={clsx(
          "landing-price-list",
          "margaux-motin-price-list",
          className
        )}
      >
        {(price || product_price_vae || product_price_vad || priceSubtitle) && (
          <FlexBox direction="column" gap={0}>
            {/* Display prices based on VAE and VAD values */}
            {!product_price_vae ||
            !product_price_vad ||
            product_price_vae === product_price_vad ? (
              price && (
                // No VAE or VAD values, show normal price
                <FlexBox direction="column" gap={0}>
                  {renderDisplayFromMention()}
                  <Typography variant="margauxBig" color="white">
                    {price}
                  </Typography>
                </FlexBox>
              )
            ) : (
              // Values are different, show both with tags
              <FlexBox direction="row" gap={24} align="center">
                <FlexBox gap={8} direction="column" align="flex-start">
                  <PriceTag label={vaeLabel || "À EMPORTER"} />
                  <Typography variant="margaux4">
                    {product_price_vae}
                  </Typography>
                </FlexBox>
                <Divider
                  direction="vertical"
                  size={30}
                  weight={1}
                  color="#6C6C6C"
                />
                <FlexBox gap={8} direction="column" align="flex-start">
                  <PriceTag label={vadLabel || "EN LIVRAISON"} />
                  <Typography variant="margaux4">
                    {product_price_vad}
                  </Typography>
                </FlexBox>
              </FlexBox>
            )}

            {/* subtitle */}
            {priceSubtitle && (
              <Typography variant="margaux4" mt={-10}>
                {priceSubtitle}
              </Typography>
            )}
          </FlexBox>
        )}
      </div>
    </_MargauxMotinPriceListRoot>
  );
};

export default MargauxMotinPriceList;
